import React, { useEffect, useState } from 'react';
import { labels } from './labels';

//const google = (window as any).google;

const FadAlert = ({ age }) => {
    const [show, setShow] = useState(true);

    if (show) {
        document.body.style.paddingRight = "-1";
    } else {
        document.body.style.paddingRight = "0";
    }    

    return (<>
        <div className="modal" tabIndex={-1} aria-labelledby="moreFiltersLabel" aria-hidden="true" style={{ display: show ? "block" : "none" }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-body p-4">
                        {labels.search.fadAlert(age)}
                        <br />
                        <div className="text-center mt-3">
                            <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={() => setShow(false)}>{labels.home.alert.continue}</button>
                        </div>
                    </div>
                    {/*
                    <div className="modal-footer">
                        
                    </div>*/}
                </div>
            </div>
        </div>
        {show && <div className={"modal-backdrop fade show"}></div>}
    </>
    );
}

export default FadAlert;